import { createStore } from 'vuex'

import main from './modules/store.main'
import cart from './modules/store.cart'
import search from './modules/store.search'

const store = createStore({
    modules: {
        main,
        cart,
        search
    }
})

export default store